export function getLoginRedirectPath(location: {
  pathname: string;
  search: string;
  hash: string;
}): string {
  if (location.pathname === "/login" || location.pathname === "/logout") {
    return "/login";
  }
  const returnTo = location.pathname + location.search + location.hash;
  return `/login?redirectTo=${encodeURIComponent(returnTo)}`;
}
